<template lang="pug">
  q-input(v-model="model" v-bind="$attrs")
    template(v-if="action" v-slot:append)
      q-btn(:icon="icon" color="indigo" flat dense rounded @click="action" :disable="!can")
        q-tooltip {{ tooltip }}
</template>

<script>
import { toString, toNumber } from 'lodash'

export default {
  props: ['value', 'action', 'tooltip', 'can', 'decimal', 'icon'],
  computed: {
    decimalReal() {
      if (this.decimal === undefined) {
        return 3
      }
      return this.decimal === 0 ? 0 : this.decimal + 1
    },
    model: {
      get() {
        return this.maskNumber(this.value)
      },
      set(val) {
        let v = this.unmaskNumber(val)
        if (v.indexOf('.') !== -1) {
          v = v.substring(0, v.indexOf('.') + this.decimalReal)
          v = this.$trimTrailingZero(v)
        }

        this.$emit('input', toNumber(v))
      }
    }
  },
  methods: {
    maskNumber(value) {
      return toString(value).replace(/,/g, '').replace(/(?<!\..*)(\d)(?=(?:\d{3})+(?:\.|$))/g, '$1,')
    },
    unmaskNumber(value) {
      return toString(value).replace(/,/g, '').replace(/[^0-9\.]+/g, '').replace(/^0[0,]+\./, '0.')
    }
  }
}
</script>
